import * as React from "react";
import { ISocialComponent } from "src/ScrollyInterface";
import "./Social.scss";

import Facebook_btn from "../../assets/Icons/White/Facebook_btn.svg";
import Twitter_btn from "../../assets/Icons/White/Twitter_btn.svg";
import Whatsapp_btn from "../../assets/Icons/White/Whatsapp_btn.png";

const social = (props: ISocialComponent) => {
  const whatsappLink = `whatsapp://send?text=${window.location.origin.toString()}`;
  const { links } = props;
  return (
    <div className={`Social-container-${props.navType}`}>
      <a href={links.twitter} target="_blank" className="Social-item">
        <img src={Twitter_btn} />
      </a>
      <a href={whatsappLink} target="_blank" className="Social-item">
        <img width="30px" height="30px" src={Whatsapp_btn} />
      </a>
      <a href={links.facebook} target="_blank" className="Social-item">
        <img src={Facebook_btn} />
      </a>
    </div>
  );
};

export default social;



// WEBPACK FOOTER //
// ./src/components/Navigation/Social.tsx